module.exports = __webpack_public_path__ + "static/media/knowledge_center.1c601be7.svg";